/**
 * The one definition of a claim scope and its key.
 *
 * `TaskClaimScope` existed three times — `domain/tasks/repository.ts`,
 * `services/tasks.ts`, and `pages/TaskQueuePage/claimOptions.ts` — and
 * `claimScopeKey` twice, in two of those. The key is the identity a claim
 * count is stored under, so two implementations of it is two chances for the
 * queue to look up a count that was written under a different string.
 *
 * It lives in `domain/taskQueue` because every consumer (the service, the
 * repository port, the queue page) is downstream of the domain.
 */
export interface TaskClaimScope {
  taskTypeId: string;
  /** Null or absent for a task type with no domain split. */
  domainId?: string | null;
}

export function claimScopeKey(taskTypeId: string, domainId?: string | null): string {
  return domainId ? `${taskTypeId}::${domainId}` : taskTypeId;
}
